import React from "react";
import "../styles/spinner.css";

function LoadingSpinner() {
  return (
    <div className="spinner-container"> 
    <div className="box1"> 
     <div className="spinitem"> <div className="loading-spinner"></div></div>
      <div className="loadhead">Loading Results</div>
    </div>
    </div>
  );
}

export default LoadingSpinner;